<template>

  <div class="required form-group col-md-6 form-ok">

    <label for="company_id">
      <dlnk-custom-text
          config="DAENTREPRISE-COMMUNITY-SELECT-LABEL"
          default="Votre communauté"
      >
      </dlnk-custom-text>
    </label>
    <input type="text" class="is_required validate form-control" v-model="query">
    <ul class="list-group mt-1 position-absolute">
      <li v-for="community in communities" :value="community.id_customer" class="list-group-item list-group-item-action">
        {{community.company}} <span v-if="community.school">({{ community.school.code }} - {{ community.school.city }})</span>
      </li>
    </ul>

  </div>

</template>

<script>

export default {
  props: [],
  data: function () {
    return {
      message: '',
      messsage_type: '',

      communities: Array(),
      community_selected: "",
      query: "",
    }
  },
  mounted() {
  },

  computed: {},

  watch: {
    query: function (new_val, old_val) {
      if (new_val.length > 2) {
        this.get_data()
      } else {
        this.communities = []
      }
    },
  },

  methods: {

    setSelected: function () {
      alert('coucou')
    },

    get_data: async function () {
      const _this = this;

      let [secure_key, customer_id, api_url] = await get_token_2()
      api_url += "/communities.json"
      api_url += '?secure_key=' + secure_key
      api_url += '&customer_id=' + customer_id

      if (_this.query.length > 2) {
        api_url += '&search=' + _this.query
      }

      axios.get(api_url)
          .then(function (response) {
            _this.communities = response.data.communities
          })
          .catch(function (error) {
            _this.message = "Erreur";
            _this.message_type = "alert-danger"
          })
          .then(function () {
                // always executed
              }
          );
    },

  },

}
</script>
